// 2026-10-17 FBA 备货采购单(第十七轮第一期)
export default {
  "+ FBA 备货": "+ FBA replenishment",
  "FBA 备货": "FBA replenishment",
  "普通采购": "Regular purchase",
  "新建 FBA 备货采购单": "New FBA replenishment PO",
  "编辑 FBA 备货采购单": "Edit FBA replenishment PO",
  "亚马逊店铺": "Amazon store",
  "选亚马逊店铺": "Select an Amazon store",
  "本公司还没接亚马逊店铺": "No Amazon store connected yet",
  "要求到仓日期": "Required arrival date",
  "要求到仓": "Required arrival",
  "比如 月结 30 天": "e.g. Net 30",
  "报价单号": "Quote no.",
  "报价日期": "Quote date",
  "报价": "Quote",
  "从 Excel 导入": "Import from Excel",
  "选文件(产品清单 / 装箱表)": "Choose file (product list / packing sheet)",
  "会替换下面的明细;单价按合同来货价自动带": "Replaces the lines below; unit prices come from the contract price",
  "保存时按合同价": "Contract price on save",
  "至少 1 行": "At least 1 line",
  "读到 {n} 个 SKU · 可售 {s} 件 · 配件 {c} 件": "Read {n} SKUs · {s} saleable units · {c} component units",
  "{m} 个对不上产品库,没加进来(见下面红字)": "{m} not found in the product list and left out (see red notes below)",
  "已建 {no} · 下一步在详情里检查、提交审批": "Created {no} · next: check it and submit for approval in the details",
  "可售 {s} 件 · 配件 {c} 件": "{s} saleable · {c} components",
  "第 {rev} 版": "Revision {rev}",
  "检查通过,可以提交审批": "Checks passed, ready to submit for approval",
  "推给供应商失败": "Push to supplier failed",
  "已推给 {company}": "Pushed to {company}",
  "还差": "Still waiting for",
  "已完成": "Done",
  "已批准": "Approved",
  "批准第 {rev} 版?可以写一句意见(可不写)": "Approve revision {rev}? You can add a comment (optional)",
  "意见(可不写)": "Comment (optional)",
  "驳回理由(必填)": "Reason for rejection (required)",
  "驳回要写理由": "A reason is required to reject",
  "撤回改版": "Withdraw to revise",
  "撤回改版?本版已有的批准会作废,改完要重新提交、两人重批。": "Withdraw to revise? Approvals on this revision are voided; after editing it must be resubmitted and approved by both again.",
  "重推": "Push again",
  "重推给供应商": "Push to supplier again",
  "看历次版本": "Show revisions",
  "收起版本": "Hide revisions",
  "会签人": "Co-approver",
  "会签:审批人和会签人都要批同一版本": "Co-sign: approver and co-approver must both approve the same revision",
  "先选审批人,再选会签人": "Select the approver first, then the co-approver",
  "会签人不能和审批人是同一个人": "The co-approver cannot be the approver",
  "可不设(只要审批人批)": "Optional (approver only)",
  "亚马逊 FBA 备货要用的 ASIN / FNSKU 也记在这里(平台 SKU = Seller SKU,跟产品编号一样也可以)。":
    "ASIN / FNSKU for Amazon FBA replenishment are kept here too (platform SKU = Seller SKU; it may equal the product code).",
  "亚马逊店铺(FBA 用,可不填)": "Amazon store (for FBA, optional)",
  "改对照 · {alias}": "Edit mapping · {alias}",
  "文件里有 {n} 个 SKU 的 ASIN / FNSKU 还没进平台 SKU 对照": "{n} SKUs in the file have ASIN / FNSKU not yet in Platform SKU mapping",
  "存进平台 SKU 对照": "Save to Platform SKU mapping",
  "(Seller SKU 先按文件里的 SKU,核对后可改)": "(Seller SKU = the SKU in the file for now; verify and edit later)",
  // ── 2026-10-18 第二期:算账 · 进度 · FBA 出货单 · FBA 库存报表 ──
  "先选店铺和报表文件": "Choose a store and a report file first",
  "可售 {a} · 预留 {r} · 不可售 {u} · 入库中 {i}(处理中 {w} / 已发运 {s} / 接收中 {c})· 数据时间 {t}": "Available {a} · reserved {r} · unfulfillable {u} · inbound {i} (working {w} / shipped {s} / receiving {c}) · data as of {t}",
  "上传 FBA 库存报表": "Upload FBA inventory report",
  "卖家后台 → 库存 → 库存报告 → 下载「管理亚马逊库存」(或「库存规划」)报表,原样上传 · 在库 = 可售;预留 / 不可售 / 入库中存在分项里 · 只写差额流水,不另外过账": "Seller Central → Inventory → Inventory reports → download “Manage FBA Inventory” (or “FBA Inventory”) and upload it as is · on hand = available; reserved / unfulfillable / inbound are kept as a breakdown · only the differences are posted, nothing else",
  "选报表文件": "Choose report file",
  "预览": "Preview",
  "上次同步 {t}": "Last synced {t}",
  "报表 {rows} 行 · 对上 {m} 个产品 · 可售 {a} 件 · 入库中 {i} 件 · 要变动 {c} 行": "{rows} report rows · {m} products matched · {a} available · {i} inbound · {c} rows will change",
  "会新建仓库「亚马逊FBA虚拟仓」": "will create the “Amazon FBA virtual warehouse”",
  "报表时间 {t}": "Report time {t}",
  "台账": "Ledger",
  "差额": "Difference",
  "预留": "Reserved",
  "不可售": "Unfulfillable",
  "入库中": "Inbound",
  "报表里没有、台账里有数的 {n} 个产品会对齐成 0:{codes}": "{n} products missing from the report but stocked in the ledger will be set to 0: {codes}",
  "{n} 个 Seller SKU 对不上产品(到「产品库 → 平台 SKU 对照」里补,补好再传一次):": "{n} Seller SKUs didn't match a product (add them in Products → Platform SKU mapping, then upload again):",
  "确认对齐": "Confirm sync",
  "标准空运": "Standard air",
  "国际快递": "Express air",
  "海运": "Sea",
  "运输方案": "Transport options",
  "报价每次找货代、人工录(整票总额 + 有效期)· 空着 = 未知,不当 0": "Enter each forwarder quote by hand (shipment total + validity) · blank = unknown, never zero",
  "选用": "Selected",
  "方案": "Option",
  "报价总额": "Quote total",
  "时效(天)": "Transit (days)",
  "有效期至": "Valid until",
  "报价计费重(kg)": "Quoted chargeable (kg)",
  "体积重除数": "Volumetric divisor",
  "包含 / 不含 / 贸易条款": "Inclusions / exclusions / Incoterm",
  "比如 DDP 含税到仓 / 不含清关": "e.g. DDP incl. duty to FC / excl. clearance",
  "算账参数": "Economics inputs",
  "金额都按报告币种;汇率 = 1 外币是多少元": "Amounts are in the reporting currency; FX = CNY per 1 unit of foreign currency",
  "报告币种": "Reporting currency",
  "汇率 {ccy}": "FX rate {ccy}",
  "汇率日期": "FX date",
  "关税 %": "Duty %",
  "清关 / 保险 / 派送(整票)": "Clearance / insurance / delivery (shipment)",
  "贴标备货费(每件)": "Labelling & prep (per unit)",
  "佣金 %": "Referral fee %",
  "退货率 %": "Return rate %",
  "退货额外损失 %": "Extra loss per return %",
  "退货率来源": "Return-rate source",
  "比如 2026-07~09 结算报告,退 12 / 售 240": "e.g. 2026-07~09 settlement reports, 12 returned / 240 sold",
  "广告占净收入 %": "Ads % of net revenue",
  "目标毛利率 %": "Target margin %",
  "每个可售 SKU 的售价和亚马逊费用": "Selling price and Amazon fees per saleable SKU",
  "每件 · 报告币种 · FBA 配送费接口通之前手填 · 配件不用填": "Per unit · reporting currency · enter FBA fees by hand until the API is connected · not needed for accessories",
  "FBA 配送费": "FBA fulfillment fee",
  "仓储估算": "Storage estimate",
  "保存算账": "Save economics",
  "保存后下面的结果会重算;改了就是新版本,要重新提交审批": "Results below recalculate after saving; any change is a new revision that must be resubmitted",
  "已核实": "Verified",
  "报价过期": "Quote expired",
  "头程": "Inbound freight",
  "到岸成本": "Landed cost",
  "广告后贡献": "Contribution after ads",
  "广告空间": "Ads headroom",
  "资金需求": "Cash required",
  "有售价的 {a} / {b} 件": "{a} / {b} units priced",
  "没有报价": "No quote",
  "估算,缺:": "Estimate, missing: ",
  "来货 {a} + 配件 {b} + 头程 {c} + 关税 {d} + 清关等 {e} + 贴标 {f}": "Purchase {a} + accessories {b} + freight {c} + duty {d} + clearance etc. {e} + labelling {f}",
  "亚马逊费用": "Amazon fees",
  "退货损失": "Return loss",
  "广告前贡献": "Contribution before ads",
  "广告费": "Ads",
  "贡献率": "Margin",
  "每件 · {ccy} · 头程、清关等共用费用按货值分摊一次;配件货值摊进可售件 · 红色 = 广告后贡献是负的": "Per unit · {ccy} · shared freight / clearance allocated once by value; accessory cost spread over saleable units · red = negative contribution after ads",
  "待装箱": "To pack",
  "数量对不上": "Qty mismatch",
  "等重批": "Awaiting re-approval",
  "装箱被驳回": "Packing rejected",
  "装箱已核": "Packing checked",
  "备货中": "Preparing",
  "已交货代": "Handed to forwarder",
  "按实际装箱批准第 {rev} 版?可以写一句意见(可不写)": "Approve revision {rev} based on actual packing? Optional comment",
  "批准实际装箱": "Approve actual packing",
  "驳回理由(必填)· 发货公司要重新装箱": "Rejection reason (required) · the shipping company must repack",
  "驳回实际装箱": "Reject actual packing",
  "{sh} 实际装箱超出批准方案,要两人按实际装箱重批(第 {rev} 版)": "{sh}: actual packing exceeds the approved option; both approvers must re-approve (revision {rev})",
  "实际:{n} 箱 · 毛重 {g} kg · 计费重 {c} kg": "Actual: {n} cartons · gross {g} kg · chargeable {c} kg",
  "已驳回 {sh} 的实际装箱:{reason} · 等发货公司重新装箱": "Rejected the actual packing of {sh}: {reason} · waiting for the shipping company to repack",
  "算账": "Economics",
  "进度": "Progress",
  "批准后自动推给供应商,这里会显示链路各家的单子和发货公司的出货单进度": "Once approved it's pushed to the supplier automatically; each company's order and the shipping company's shipment progress show here",
  "装箱": "Packing",
  "{n} 箱 · {g} kg": "{n} cartons · {g} kg",
  "亚马逊货件": "Amazon shipment",
  "目的仓": "Destination FC",
  "头程运单": "Inbound waybill",
  "发货公司还没建 FBA 出货单": "The shipping company hasn't created the FBA shipment yet",
  "头程运费、关税的账单到了,点下面「调整运费」填进入库运费 → 按货值摊进每个产品的落地成本(FBA 订单成本从这里取)": "When the freight and duty bills arrive, enter them under “Adjust freight” below → allocated by value into each product's landed cost (FBA order cost comes from here)",
  "等 CK 重批": "Awaiting CK re-approval",
  "文件里没有箱子": "No cartons in the file",
  "读到 {n} 箱": "{n} cartons read",
  "核对后点保存": "check and save",
  "备货清单": "Prep list",
  "头程运单号(货代给的)": "Inbound waybill no. (from the forwarder)",
  "填运单号": "Enter waybill",
  "确认发货(整条链记已发货、开链路发票)": "Confirm shipped (whole chain marked shipped, chain invoices issued)",
  "放行交货代": "Release to forwarder",
  "待建 FBA 出货单 · {n} 张": "FBA shipments to create · {n}",
  "源头采购单": "Source PO",
  "建 FBA 出货单": "Create FBA shipment",
  "FBA 备货出货单": "FBA replenishment shipments",
  "上游 FBA 备货采购单两人批准后推到这里 · 一个亚马逊货件一张": "Pushed here after both approve the upstream FBA replenishment PO · one per Amazon shipment",
  "还没有 FBA 备货单 · 由上游公司的 FBA 备货采购单批准后推来": "No FBA replenishment orders yet · they arrive once an upstream FBA replenishment PO is approved",
  "装箱回填 / 详情": "Enter cartons / details",
  "下载备货清单": "Download prep list",
  "FBA 出货单 {no}": "FBA shipment {no}",
  "下载 Excel": "Download Excel",
  "按清单备货、贴 FNSKU 商品标签;缺货先说明,不能私自换 SKU": "Prepare exactly this list and apply FNSKU labels; report shortages first — never substitute SKUs",
  "装箱回填": "Carton return",
  "实际装箱超出批准方案(或批准时没有报价比不了),已请 {company} 两人按实际装箱重批 · 批完才能放行": "Actual packing exceeds the approved option (or there was no quote to compare); {company}'s two approvers have been asked to re-approve · release only after that",
  "已批:{names}": "Approved by: {names}",
  "改好装箱再保存": "fix the packing and save again",
  "一行一个产品;箱号、外箱长宽高(mm)、毛重(kg)写在这箱第一行,混装箱同一箱号往下加行。也可以下载备货清单,填第 2 页「装箱回填」后上传。": "One product per row; carton no., outer L/W/H (mm) and gross weight (kg) go on the carton's first row; for mixed cartons add rows with the same carton no. Or download the prep list, fill sheet 2 “Carton return” and upload it.",
  "上传装箱回填 Excel": "Upload carton Excel",
  "长(mm)": "L (mm)",
  "宽(mm)": "W (mm)",
  "高(mm)": "H (mm)",
  "+ 本箱加一行(混装)": "+ Row in this carton (mixed)",
  "+ 新的一箱": "+ New carton",
  "共 {n} 箱": "{n} cartons",
  "上次保存:{n} 箱 · 毛重 {g} kg · 体积重 {v} kg · 计费重 {c} kg · {cbm} m³": "Last saved: {n} cartons · gross {g} kg · volumetric {v} kg · chargeable {c} kg · {cbm} m³",
  "计划发货日": "Planned ship date",
  "测量证据": "Measurement evidence",
  "比如 照片在企业微信群 10-18": "e.g. photos in the WeCom group 10-18",
  "保存装箱 · 核对": "Save cartons · check",
  "数量还没对上,也能先存": "quantities don't match yet — you can still save",
  "在卖家后台建好入库货件后填(接口通之后自动带)": "Fill in after creating the inbound shipment in Seller Central (automatic once the API is connected)",
  "货件号": "Shipment ID",
  "确认号": "Reference ID",
  "上游 FBA 备货采购单两人批准后推来 · 建好后在下面列表里「装箱回填」": "Pushed here after both approve the upstream FBA replenishment PO · once created, use “Enter cartons” in the list below",
  // 2026-10-20 补货预警(第十七轮第五期)
  "FBA 补货": "FBA replenishment",
  "YES 之后": "After YES",
  "{d} 复查": "review {d}",
  "{d} 天": "{d} days",
  "{h} 小时": "{h} h",
  "{lv} 级 · 库存位置 {p} · 日均 {d} · 可撑 {c} 天 · 建议补 {s}": "Level {lv} · stock position {p} · daily avg {d} · {c} days of cover · suggested {s}",
  "一级 · 紧急": "Level 1 · Urgent",
  "三级 · 中": "Level 3 · Medium",
  "不补": "Don't replenish",
  "不设 = 有这页写权限的人都能决定": "Not set = anyone with write access to this page can decide",
  "二级 · 高": "Level 2 · High",
  "亚马逊上架天数": "Amazon receiving days",
  "产品上填了安全库存 / 采购提前期 / 起订量 / 箱规的,优先用产品上的。某个产品不想再预警:在「全部产品」里点「停补」。": "Safety stock / lead time / MOQ / case pack filled in on a product take priority. To stop alerts for a product, click \"Stop\" in \"All products\".",
  "仓库补货": "Warehouse replenishment",
  "停补": "Stop",
  "全部产品": "All products",
  "决定": "Decide",
  "决定不补": "Won't replenish",
  "决定不补要写理由": "A reason is required when not replenishing",
  "决定人": "Decider",
  "决定人见设置": "decider in settings",
  "决定补": "Will replenish",
  "到这天还在风险里会重新打开": "Reopens on this date if it's still at risk",
  "只看要补的": "Only items to replenish",
  "只记录决定和数量": "Only record the decision and quantity",
  "可售 {a} + 入库中 {b} + 已批未发 {c}": "Available {a} + inbound {b} + approved not shipped {c}",
  "可撑天数": "Days of cover",
  "可撑天数 / 断货日": "Days of cover / stock-out",
  "四级 · 低": "Level 4 · Low",
  "处理时限(小时)": "Response time (hours)",
  "备用决定人": "Backup decider",
  "备货天数": "Prep days",
  "复查日期": "Review date",
  "安全库存天数": "Safety stock days",
  "已停补 · 这个产品不再预警": "Stopped · no more alerts for this product",
  "已决定": "Decided",
  "已决定 / 结束": "Decided / closed",
  "已决定 · 生成了 FBA 备货采购单草稿 {no}": "Decided · draft FBA replenishment PO {no} created",
  "已恢复补货预警 · 下次计算生效": "Alerts resumed · takes effect at the next calculation",
  "已结束": "Closed",
  "已超时 {t}": "Overdue by {t}",
  "已重算 · 新开 {o} · 升级 {u} · 结束 {c}": "Recalculated · {o} new · {u} escalated · {c} closed",
  "库存 = 亚马逊FBA虚拟仓可售 + 入库中 + 已批准还没发的 FBA 备货采购单 · 需求 = 亚马逊 FBA 订单": "Stock = FBA virtual warehouse available + inbound + approved FBA replenishment POs not yet shipped · demand = Amazon FBA orders",
  "库存 = 智邦添来仓(中间件库存快照)− 还没发的单 · 需求 = 本公司销售单(各渠道推来的单 + FBA 备货)按下单日算日均": "Stock = Zhibang Tianlai warehouse (middleware stock snapshot) − orders not yet shipped · demand = this company's sales orders (orders from all channels + FBA replenishment), daily average by order date",
  "库存位置": "Stock position",
  "库存数据时间 {t}": "Stock data as of {t}",
  "库存数据超过 36 小时没更新 · 不出建议(不能当 0 算)": "Stock data is over 36 hours old · no suggestions (can't treat it as 0)",
  "库存数据超过 36 小时没更新 · 这次不出建议": "Stock data is over 36 hours old · no suggestions this time",
  "建议补": "Suggested",
  "开了每天早上 7 点自动算,超时没决定的每小时升一级": "When on, it's calculated daily at 7:00; undecided alerts past their deadline are escalated hourly",
  "开启": "Enabled",
  "待决定": "To decide",
  "必填 · 比如 要改款 / 季节性 / 先清库存": "Required · e.g. redesign coming / seasonal / clear stock first",
  "恢复": "Resume",
  "提醒生产(在智邦里做,ERP 只记)": "Remind production (done in Zhibang; ERP only records)",
  "日均": "Daily avg",
  "日均 = 0.5×近 7 天 + 0.3×近 30 天 + 0.2×近 90 天 · 补货点 = 日均×交期 + 安全库存 · S 撑不到交期一半 · A 撑不到交期 · B 低于补货点 · C 一周内低于补货点": "Daily avg = 0.5×7 days + 0.3×30 days + 0.2×90 days · reorder point = daily×lead time + safety stock · S: won't last half the lead time · A: won't last the lead time · B: below reorder point · C: below reorder point within a week",
  "日均低于多少不预警": "No alert below this daily avg",
  "智邦在库 {a} − 还没发的单 {b}": "Zhibang on hand {a} − orders not shipped {b}",
  "本公司没开通{k}": "{k} is not enabled for this company",
  "没开 · 不会每天自动算": "Off · not calculated daily",
  "没有待决定的补货预警": "No replenishment alerts to decide",
  "清关天数": "Customs days",
  "理由": "Reason",
  "生产 / 采购提前期(天)": "Production / purchase lead time (days)",
  "生成 FBA 备货采购单草稿": "Create a draft FBA replenishment PO",
  "目标": "Target",
  "目标覆盖天数": "Target cover days",
  "确定后会在本公司生成一张 FBA 备货采购单草稿,再照常算账、提交会签": "This creates a draft FBA replenishment PO in this company; then cost it and submit for co-signing as usual",
  "级别": "Level",
  "补": "Replenish",
  "补 {n}": "replenish {n}",
  "补多少": "Quantity",
  "补货决定 · {code}": "Replenishment decision · {code}",
  "补货数量要大于 0": "Quantity must be greater than 0",
  "补货点": "Reorder point",
  "补货点 / 交期": "Reorder point / lead time",
  "补货预警": "Replenishment alerts",
  "补货预警设置 · {k}": "Replenishment alert settings · {k}",
  "运输天数": "Transit days",
  "近 7 天 {a} 件 · 近 30 天 {b} 件 · 近 90 天 {c} 件": "Last 7 days {a} · last 30 days {b} · last 90 days {c}",
  "还剩 {t}": "{t} left",
  "销量数据从 {d} 开始(ERP 里的单)": "Sales data starts {d} (orders in ERP)",
  "马上重算": "Recalculate now",
  "智邦库存数据太旧 · 已让中间件重新盘一次(1~3 分钟)· 过几分钟再点「马上重算」": "Zhibang stock data is too old · asked the middleware to recount (1–3 min) · click \"Recalculate now\" again in a few minutes",
  // 2026-10-20 智邦库存同步
  "已同步智邦库存 · {m} 个产品对上 · {c} 个有变动": "Zhibang stock synced · {m} products matched · {c} changed",
  "{u} 个智邦编号产品库里没有": "{u} Zhibang codes aren't in the product library",
  "木制品成品仓 · 跟智邦同步 · 数据时间 {t}": "Wood finished-goods warehouse · synced with Zhibang · as of {t}",
  "木制品成品仓还没同步过智邦": "Wood finished-goods warehouse hasn't synced with Zhibang yet",
  "同步智邦库存": "Sync Zhibang stock",
  "跟智邦「木制品成品仓（添来仓）」同步 · 数据时间 {t}": "Synced with Zhibang \"Wood finished-goods warehouse (Tianlai)\" · as of {t}",
  "先从智邦同步了库存({n} 个产品有变动)": "Synced stock from Zhibang first ({n} products changed)",
  "库存 = 「木制品成品仓」台账(每 30 分钟跟智邦添来仓对齐)− 还没发的单 · 需求 = 本公司销售单(各渠道推来的单 + FBA 备货)按下单日算日均": "Stock = \"Wood finished-goods warehouse\" ledger (aligned with Zhibang Tianlai warehouse every 30 min) − orders not yet shipped · demand = this company's sales orders (orders from all channels + FBA replenishment), daily average by order date",
  // 2026-10-27 司南聚水潭库存同步
  "关联司南聚水潭": "Link Sinan Jushuitan",
  "取消关联司南聚水潭": "Unlink Sinan Jushuitan",
  "关联后「{me}」的数以司南聚水潭为准:每 30 分钟按聚水潭的实际库存对齐,ERP 的发货单出库 / 采购收货不再往这个仓记账。": "Once linked, \"{me}\" follows Sinan Jushuitan: aligned to Jushuitan's actual stock every 30 min, and ERP shipments / purchase receipts no longer post to this warehouse.",
  "取消关联后「{me}」不再跟司南聚水潭对齐,现有的数留着,以后由 ERP 自己记账。": "After unlinking, \"{me}\" no longer follows Sinan Jushuitan; current quantities stay and ERP keeps its own ledger from now on.",
  "打开 = 这个仓的数以司南聚水潭为准(实际库存),每 30 分钟对齐,ERP 的发货单 / 采购收货不往里记账。一家公司只关联一个仓。关掉 = 取消关联,数留着。": "On = this warehouse follows Sinan Jushuitan (actual stock), aligned every 30 min; ERP shipments / receipts don't post here. One warehouse per company. Off = unlink, quantities stay.",
  "已同步司南聚水潭库存 · {m} 个产品对上 · {c} 个有变动": "Sinan Jushuitan stock synced · {m} products matched · {c} changed",
  "{u} 个聚水潭编号产品库里没有": "{u} Jushuitan codes not in the product library",
  "还没有仓库关联司南聚水潭": "No warehouse linked to Sinan Jushuitan",
  "{wh} · 跟司南聚水潭同步 · 数据时间 {t}": "{wh} · synced with Sinan Jushuitan · as of {t}",
  "{wh} 还没同步过司南聚水潭": "{wh} has not synced with Sinan Jushuitan yet",
  "同步司南库存": "Sync Sinan stock",
  "跟司南聚水潭同步 · 实际库存 {q} · 订单占有 {l} · 可用 {a} · 数据时间 {t}": "Synced with Sinan Jushuitan · actual {q} · held by orders {l} · available {a} · as of {t}",
  "占 {n}": "held {n}",
} as Record<string, string>;
